<template>
  <section
    id="about"
    class="co-bg-striped"
  >
    <div class="co-container-lg px-4 py-12 text-center sm:py-16 md:px-0">
      <h2 class="co-display-7 co-mb-16 tracking-[.15em]">
        テックアカデミーキャリアについて
      </h2>
      <p class="co-display-10 pt-5 text-co-gray-500">
        <span class="inline md:block">ご登録していただいたプロフィールや、学習で身につけたスキルを元に</span><span class="inline md:block">企業やコンサルタントからスカウトメッセージが届きます。</span><span class="inline md:block">受講開始後すぐに無料でご利用になれるテックアカデミー受講生限定の転職サービスです。</span>
      </p>
    </div>
  </section>
</template>
